module.exports = __webpack_public_path__ + "static/media/layout-5.30e725ea.svg";